import { useMemo } from "react";

export const useQueryParams = () => {
  return useMemo(() => (new URL(document.location)).searchParams, []);
};
